module.exports = __webpack_public_path__ + "static/fourpcpinkfloral2-3a2e9817acab1f2f391228286a90bb5e.jpeg";